export default {
    getData(data) {
        return axios.post('/api/member/getData', data);
    }
};
